'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { memoize } from 'underscore';
import GoodImageTypes from 'marketplace-lib/constants/GoodImageTypes';
import GoodSubTypes from '../../constants/GoodSubTypes';
import { getEnglishTextFieldFromTextsMap } from '../../utils/utils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISection from 'UIComponents/section/UISection';
import GoodTile from 'marketplace-lib/components/goods/GoodTile';
import GoodTileLink from '../GoodTileLink';
import withPartials from 'marketplace-lib/components/hocs/withPartials';
import GoodSubTypeDropdown from '../GoodSubTypeDropdown';
var getI18nKey = memoize(function (path) {
  return "MarketplaceUI.goodDetailsPage.packContents." + path;
});

var PackContents = /*#__PURE__*/function (_PureComponent) {
  _inherits(PackContents, _PureComponent);

  function PackContents(props) {
    var _this;

    _classCallCheck(this, PackContents);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PackContents).call(this, props));
    _this.handleSubTypeChange = _this.handleSubTypeChange.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedSubType: GoodSubTypes.ALL
    };
    return _this;
  }

  _createClass(PackContents, [{
    key: "handleSubTypeChange",
    value: function handleSubTypeChange(event) {
      this.setState({
        selectedSubType: event.target.value
      });
    }
  }, {
    key: "renderPackChildLink",
    value: function renderPackChildLink(urlToken, props) {
      return React.createElement(GoodTileLink, Object.assign({}, props, {
        goodUrlToken: urlToken
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          goodDetails = _this$props.goodDetails,
          packChildrenSubTypes = _this$props.packChildrenSubTypes,
          partial = _this$props.partial,
          previewMode = _this$props.previewMode,
          trackLinkClick = _this$props.trackLinkClick;
      var selectedSubType = this.state.selectedSubType;
      var packChildren = goodDetails.get('children');
      var filteredPackChildren = packChildren.filter(function (child) {
        if (selectedSubType === GoodSubTypes.ALL) {
          return true;
        }

        return child.get('subType') === selectedSubType;
      });
      return React.createElement("div", {
        className: "pack-contents",
        "data-test-id": "pack-contents"
      }, packChildrenSubTypes && packChildrenSubTypes.length > 1 && React.createElement(UISection, null, React.createElement(UIFlex, {
        align: "baseline",
        justify: "between"
      }, React.createElement(GoodSubTypeDropdown, {
        buttonClassName: "integrate-pack-contents-filter",
        onSubTypeChange: this.handleSubTypeChange,
        subTypeOptions: packChildrenSubTypes,
        value: selectedSubType
      }), React.createElement(FormattedHTMLMessage, {
        message: getI18nKey('filteredCount'),
        options: {
          filteredCount: filteredPackChildren.size,
          totalCount: packChildren.size
        }
      }))), React.createElement(UISection, null, React.createElement(UIGrid, null, filteredPackChildren.map(function (child, index) {
        var childUrlToken = child.get('urlToken');
        return React.createElement(UIGridItem, {
          key: index,
          size: {
            xs: 4
          }
        }, React.createElement(GoodTile, {
          goodImageUrl: child.getIn(['images', GoodImageTypes.MARKETING_IMAGE_SMALL]),
          goodName: getEnglishTextFieldFromTextsMap('NAME', child.get('texts')),
          goodPrice: child.get('price'),
          goodSubType: child.get('subType'),
          goodType: child.get('type'),
          goodUrlToken: childUrlToken,
          linkRenderer: partial(_this2.renderPackChildLink, childUrlToken),
          onClick: partial(trackLinkClick, 'good-tile'),
          onPackDetailsPage: true,
          previewMode: previewMode
        }));
      }))));
    }
  }]);

  return PackContents;
}(PureComponent);

PackContents.propTypes = {
  goodDetails: PropTypes.instanceOf(Immutable.Map).isRequired,
  packChildrenSubTypes: PropTypes.arrayOf(PropTypes.string),
  partial: PropTypes.func.isRequired,
  previewMode: PropTypes.bool.isRequired,
  trackLinkClick: PropTypes.func.isRequired
};
export default withPartials(PackContents);